import { useConfigurationSelector } from "@nf/common";

const DEFAULT_LOGO = "/assets/app/app-header-logo-transparent.png";

export const useBrandingLogo = () => {
  const configuration = useConfigurationSelector();
  return configuration?.Branding?.WebHeaderLogoUrl ?? DEFAULT_LOGO;
};
